module.exports = __webpack_public_path__ + "media/images/flags/32/Canada-435882f2c0a292f331f77fa72f0530b0.png";